import * as e from "react";
import { forwardRef as r } from "react";
const n = r(function(t, l) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: l,
      viewBox: "0 0 24 20",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("path", { d: "M19.5703 20H0L3.42965 0H23L19.5703 20Z", fill: "#FFCA00" }),
    /* @__PURE__ */ e.createElement("g", { clipPath: "url(#prefix__clip0_8119_316)" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.07 6.74L10.54 4.27V2L6.5 6.04V12.69L8.07 11.12V6.74Z",
        fill: "#444"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.78 7.97995L13.89 4.86995V2.44995L9.1 7.23995V15.29L10.78 13.61V7.97995Z",
        fill: "#444"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17.45 2.89001L11.81 8.52001V18L17.45 12.37V2.89001Z",
        fill: "#444"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "prefix__clip0_8119_316" }, /* @__PURE__ */ e.createElement(
      "rect",
      {
        fill: "#fff",
        height: 16,
        transform: "translate(6.5 2)",
        width: 10.95
      }
    )))
  );
});
export {
  n as BetBuilderBadge
};
